import { makeStyles } from '@material-ui/core/styles'
import { leftSidebarSettingsWidth } from 'src/Constants'

export const layerLegendStyle = makeStyles((theme) => ({
  root: {
    width: leftSidebarSettingsWidth,
    height: '100%',
    backgroundColor: theme.palette.secondary.main,
    padding: theme.spacing(2),
    borderTop: 1,
    borderTopStyle: 'solid',
    borderTopColor: theme.palette.primary.main,
    borderBottom: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: theme.palette.primary.main
  },
  layer: {
    display: 'flex',
    flexDirection: 'row'
  },
  layerWithWikiDocument: {
    cursor: 'pointer'
  },
  color: {
    marginLeft: theme.spacing(1),
    minWidth: '20px',
    minHeight: '20px',
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.common.black
  },
  selectedColor: {
    marginLeft: theme.spacing(1),
    minWidth: '20px',
    minHeight: '20px',
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
    borderWidth: 1.5,
    borderStyle: 'solid',
    borderColor: theme.palette.common.black
  },
  description: {
    fontSize: '0.6rem'
  },
  selectedDescription: {
    fontSize: '0.7rem',
    fontWeight: 'bold'
  },
  legendText: {
    marginBottom: theme.spacing(2)
  }
}))
